import { render } from "./ConfiguracaoInicialEtapas.vue?vue&type=template&id=05cc10ca&scoped=true&ts=true"
import script from "./ConfiguracaoInicialEtapas.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialEtapas.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialEtapas.vue?vue&type=style&index=0&id=05cc10ca&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cc10ca"]])

export default __exports__